<template>
  <div class="pt-3">
    <Loader v-if="!groupUsers || (groupUsers && groupUsers.length == 0)"/>
      <div class="dashboard__container--header">
          <ais-instant-search :search-client="searchClient" index-name="a_users" >
            <ais-search-box placeholder="Add User..." />
            <ais-state-results>
              <template slot-scope="{ state: { query } }">
                <ais-hits v-show="query.length > 0">
                  <template v-slot:item="{ item }">
                    <div>
                      <button @click="addUser(item)" class="btn btn__icon btn__flat mr-4">
                        <i class="fas fa-plus" style="color:blue;" v-if="!performingRequest"></i>
                        <i class="fa fa-spinner fa-spin" style="color:blue;" v-if="performingRequest"></i>
                      </button>
                      <p style="display: inline;">{{ item.firstName }} {{ item.lastName }} | <span v-if="item.address && item.address">{{item.address.city}} | </span>{{item.email}} | {{item.phone}}</p>
                    </div>
                  </template>
                </ais-hits>
              </template>
            </ais-state-results>
          </ais-instant-search>
         
          <button class="btn btn__small btn__dark mr-3" @click="exportGroup()">export group</button>
      </div>
      <div class="dashboard__container--body pt-3" v-if="groupUsers && groupUsers.length >= 1">
          <vue-good-table
              :columns="columns"
              :rows="groupUsers"
               styleClass="vgt-table striped"
              :search-options="{
                enabled: true,
                placeholder: 'Search this table',
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 25,
              }"
            >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'photoUrl'">
                <span v-if="props.row.photoUrl">
                  <img :src="(props.row.photoUrl || `https://firebasestorage.googleapis.com/v0/b/mvpes-25aef.appspot.com/o/avatar%20copy.png?alt=media&token=966c07c4-125a-490f-81be-4e2d26bf33fa`)" alt="" style="width: 3.5rem; height:3.5rem; border-radius: 50%; padding: 0.25rem;">
                </span>
              </span>
              <span v-else-if="props.column.field == 'fullName'">
                <router-link :to="'/users/' + props.row.id" class="darkLink">
                  <h5 v-if="!props.row.blacklist || (props.row.blacklist && props.row.blacklist.length == 0)">
                  {{props.row.firstName}} {{props.row.lastName}}
                  <span v-if="props.row.beeline"><i class="fa-duotone fa-bee ml-2" style="--fa-primary-color: #6b6b6b; --fa-secondary-color: #fff700; --fa-secondary-opacity: 0.8;"></i></span>

                  </h5>
                  <h5 v-if="props.row.blacklist && props.row.blacklist.length >= 1" class="danger">
                  {{props.row.firstName}} {{props.row.lastName}}
                  <span v-if="props.row.beeline"><i class="fa-duotone fa-bee ml-2" style="--fa-primary-color: #6b6b6b; --fa-secondary-color: #fff700; --fa-secondary-opacity: 0.8;"></i></span>
                  </h5>
                </router-link>
                <div class="flex justify-flex-start mt-0">
                  <star-rating :read-only="true" :star-size="12" v-if="props.row && props.row.rating" v-model="props.row.rating" class="caption"></star-rating>
                  <span v-if="props.row && props.row.points" class="caption flex align-center">
                    {{props.row.points}} Points
                  </span>
                </div>
                <div class="flex justify-flex-start mt-0 mb-2 caption">
                  {{props.row.dob | moment("MMMM Do YYYY") }}
                </div>
              </span>
              <span v-else-if="props.column.field == 'created'">
                {{formatDate(props.row.created)}}
              </span>
              <span v-else-if="props.column.field == 'check'">
                <span v-if="props.row.backgroundCheckStatus && !props.row.backgroundCheckResponse">{{props.row.backgroundCheckStatus}}</span>
                <span v-if="props.row.backgroundCheckResponse">{{props.row.backgroundCheckResponse}}</span>
              </span>
              <span v-else-if="props.column.field == 'drug'">
                <span v-if="props.row.drugCheckStatus">{{props.row.drugCheckStatus}}</span>
                <span v-if="props.row.drugCheckResponse">{{props.row.drugCheckResponse}}</span>
              </span>
              <!-- <span v-else-if="props.column.field == 'onboarded'">
                <button v-if="props.row.evereeOnboardingComplete" class="btn btn__outlined btn__small">
                  Contractor <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
                </button>

                <button v-if="!props.row.evereeOnboardingComplete && props.row.updatePayrollReminderSent" class="btn btn__outlined btn__small">
                  Reminder Sent <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
                </button>

                <button v-if="!props.row.evereeOnboardingComplete && !props.row.updatePayrollReminderSent" class="btn btn__outlined btn__small" @click="onTextPayroll(props.row)">
                  Send Reminder
                </button>
              </span> -->
              <span v-else-if="props.column.field == 'onboardStatus'">
                <div v-if="props.row.workerId && props.row.evereeOnboardingComplete" class="caption">
                  Contractor <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
                </div>
                <div v-if="props.row.workerId && !props.row.evereeOnboardingComplete" class="caption">
                  Contractor <i class="fa-solid fa-check ml-3" style="color:#f0ad4e;"></i>
                </div>
                <div v-if="!props.row.workerId" class="caption">
                  Contractor <i class="fa-solid fa-check ml-3" style="color:#ef4b46;"></i>
                </div>
                <div v-if="!props.row.employeeId" class="caption">
                  Employee <i class="fa-solid fa-check ml-3" style="color:#ef4b46;"></i>
                </div>
                <div v-if="props.row.employeeId && !props.row.employeeOnboardingComplete" class="caption">
                  Employee <i class="fa-solid fa-check ml-3" style="color:#f0ad4e;"></i>
                </div>
                <div v-if="props.row.employeeId && props.row.employeeOnboardingComplete" class="caption">
                  Employee <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
                </div>
              </span>
              <span v-else-if="props.column.field == 'link'">
                <router-link :to="`/users/` + props.row.id" target="_blank">
                  <i class="fas fa-external-link ml-3 mr-3"></i>
                </router-link>
              </span>
              <span v-else-if="props.column.field == 'skills'">
                <span v-if="!props.row.skills || props.row.skills.length == 0">
                  <i class="fad fa-briefcase ml-2 mr-2" style="opacity:50%;"></i>
                </span>
                <span v-if="props.row.skills && props.row.skills.length > 0">
                  <v-popover>
                    <i class="fad fa-briefcase ml-2 mr-2 success"></i>
                    <template slot="popover">
                      <span v-for="z in props.row.skills">{{z.title}} / </span>
                    </template>
                  </v-popover>
                </span>
              </span>
              <span v-else-if="props.column.field == 'delete'">
          <!--       <button class="icon" v-tooltip="'delete user'" @click.prevent="deleteUser(props.row, props.index)">
                    <i class="fa-solid fa-octagon-exclamation fa-2x" style="color: red"></i>
                  </button> -->
                  
                <button class="icon" v-tooltip="'delete instance'" @click.prevent="deleteUser(props.row, props.index)">
                  <i class="fas fa-trash ml-2 mr-2"></i>
                </button>
              </span>
               <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
       
      </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import ExportService from "@/services/ExportService"
import algoliasearch from 'algoliasearch/lite';
import StarRating from 'vue-star-rating'
import router from '@/router'
import * as moment from 'moment'

export default {
  props: ['group'],
  name: 'group',
  data: () => ({
    message: '',
    activeItem: null,
    activeNote: null,
    showAll: true,
    performingRequest: false,
    performingRequest2: false,
    searchClient: algoliasearch(
        '0T1SIY6Y1V',
        'f03dc899fbdd294d6797791724cdb402',
      ),
    columns2: [
      {
        label: 'Created',
        field: 'created',
      },
      {
        label: 'message',
        field: 'message',
      },
    ],
    columns: [
      {
        field: 'photoUrl',
        sortable: false,
        width:'42px',
        tdClass: 'text-center',
      },
      {
        label: '',
        field: 'fullName',
        sortable: false,
        width:'180px',
      },
      {
        label: 'Status',
        field: 'onboardStatus',
        sortable: false,
        width:'120px',
      },
      {
        label: 'City',
        field: 'address.city',
        sortable: false,
        width:'120px',
      },
      {
        label: 'State',
        field: 'address.state',
        sortable: false,
        width:'60px',
      },
      {
        label: 'Joined',
        field: 'created',
        sortable: false,
        width:'120px',
      },
      // {
      //   label: 'Note',
      //   field: 'note',
      //   sortable: false,
      //   tdClass: 'text-left',
      //   width:'60px',
      // },
      {
        label: 'Phone',
        field: 'phone',
        sortable: false,
        width:'120px',
      },
      // {
      //   label: 'DOB',
      //   field: 'dob',
      //   sortable: false,
      //   width:'60px',
      // },
      {
        label: 'Background',
        field: 'check',
        sortable: false,
      },
      {
        label: 'Drug',
        field: 'drug',
        sortable: false,
      },
      {
        label: 'Skills',
        field: 'skills',
        sortable: false,
      },
      {
        label: 'Remove',
        field: 'delete',
        sortable: false,
      }
    ]
  }),
  computed: {
    ...mapState(['currentUser', 'userProfile', 'groupUsers']),
    // clean() {
    //   return (!this.groupUsers || this.groupUsers.length == 0)
    // },
    // isAdmin() {
    //   return this.group.admins.some(person => person.userId == this.currentUser.uid)
    // },
    // isUser() {
    //   return this.group.users.some(person => person.userId == this.currentUser.uid)
    // }
  },
  components: {
    Loader,
    StarRating
  },
  created () {
    if (!this.groupUsers || this.groupUsers.length < 1) {
      this.$store.dispatch("getGroupUsers", this.$route.params.id);
    }
  },
  methods: {
    onTextPayroll(user) {
      let newText = {
        name: user.firstName,
        phone: user.phone,
        userId: user.id,
        type: 'updatePayroll'
      }
      this.$store.dispatch('updatePayrollText', newText)
      // fb.usersCollection.doc(user.id).update({
      //   updatePayrollReminderSent: fb.firestore.FieldValue.serverTimestamp()
      // })
    },
    showNote(r) {
      console.log(r)
      this.activeItem = r
    },
    closeNote(r) {
      this.activeItem = null
    },
    showItem(r) {
      console.log(r)
      this.activeNote = r
    },
    closeItem(r) {
      this.activeNote = null
    },
    // addAll() {
    //   let group = this.group
    //   this.$store.dispatch("addAllUsersToGroup", {
    //     group: this.group
    //   })
    // },
    addUser(item) {
      console.log(item)
      let group = this.group
      this.performingRequest = true;
      this.$store.dispatch("newGroupApplicant", {
        user: item,
        group: this.group
      })
      setTimeout(() => {
        this.performingRequest = false;
        document
        .querySelectorAll('.ais-SearchBox-input')
        .forEach((e) => (e.value = ''))
        document.querySelectorAll('.ais-Hits-item').forEach((e) => e.remove())
      }, 250)
    },
    deleteUser(item, index) {
      console.log(item)
      let groupUsers = this.groupUsers
      groupUsers.splice(index, 1)
      this.$store.dispatch("removeUserFromGroup", {
        group: this.group,
        user: item
      })
      // this.$store.dispatch("getGroupFromId", this.$route.params.id);
    },


    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMMM Do YYYY')
      } else {
        return null
      }
    },
    // sendMessage () {
    //   this.performingRequest2 = true
    //   let newMessage = {
    //     groupId: this.group.id,
    //     groupUsers: this.groupUsers,
    //     message: this.message,
    //     from: this.userProfile.twilioNumber || null
    //   }
    //   this.$store.dispatch('updateGroupStaff', newMessage)
    //   setTimeout(() => {
    //       this.performingRequest2 = false,
    //       this.message = ''
    //   }, 1000)
    // },
    // updateStaff() {
    //   let group = this.group
    //   this.$store.dispatch('updateGroupStaff', group)
    // },
    updateGroup() {
      let group = this.group
      this.$store.dispatch('updateGroup', group)
    },
    deleteGroup() {
      let group = this.group
      this.$store.dispatch('deleteGroup', group)
      setTimeout(() => {
        let url = `/groups`
        router.push(url)
      }, 1000)
    },
    exportGroup() {
      let logFields = {
          user: this.currentUser.email,
          export: 'Group Export',
          group: this.group.id
      }
      this.$store.dispatch('sendExportLog', logFields)
      const exportHeaders = [
        "First Name",
        "Last Name",
        "Email",
        "Phone",
        "DOB",
        "Skills",
      ]
      const exportItems = [];
      for (var key in this.groupUsers) {

        function mySkillsFunction(groupUsers) {
          let skillsArray = []
          groupUsers[key].skills.forEach(sk => {
            skillsArray.push(sk.title)
          })
          console.log(skillsArray)
          return skillsArray.toString()
        }

        exportItems.push([
          this.groupUsers[key].firstName,
          this.groupUsers[key].lastName,
          this.groupUsers[key].email,
          this.groupUsers[key].phone,
          this.groupUsers[key].dob,
          mySkillsFunction(this.groupUsers)
          
        ])
      }
      console.log(exportItems)
      this.$gapi.getGapiClient().then(gapi => {
        const exportService = new ExportService(exportHeaders, Object.values(exportItems), gapi);
        exportService.export();
      });
    },
    onRowClick(params) {
      let url = `/users/` + params.row.id
      router.push(url)
    },
    // goBack() {
    //   router.go(-1)
    // },
  },
  beforeDestroy () {
    this.message = null
    delete this.message
    this.performingRequest = null
    delete this.performingRequest
    this.performingRequest2 = null
    delete this.performingRequest2

    delete this.deleteGroup
    delete this.addUsers
    delete this.updateGroup
    delete this.setPlace
  }
}
</script>